import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { URL } from '../../Config/appConfig';

class NotFound extends React.Component <{}, {}> {
    public render() {
        return (
            <Redirect to={URL.DASHBOARD}/>
        );
    }
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/Components/NotFound/NotFound.tsx